module.exports = __webpack_public_path__ + "img/helical_inner_right_gear.prt.2ed65a81.jpg";